@if (sale().unitId) {
    <div
        class="property-list-item"
        (click)="selectSale(sale())"
        [class.is-uncertain]="sale().isUncertain"
        [class.is-public-reg-date-only]="sale().isPublicRegDateOnly"
        [class.is-for-sale]="sale().isForSale"
        [class.hovered]="hovered"
        (mouseenter)="onMouseEnter()"
        (mouseleave)="onMouseLeave()"
    >
        <div class="icon estate" [class]="'property-' + sale().estateType"></div>
        <div class="item-data-wrapper">
            <div class="first-row">
                @if (sale().isWithdrawn || sale().isOutdated) {
                    <div class="withdrawn">T</div>
                }
                <div class="address">
                    @if (sale().streetAddress) {
                        <span>{{ sale().streetAddress | dash }}</span>
                    }
                    @if (sale().postalAddress) {
                        <span>, {{ sale().postalAddress | dash }}</span>
                    }
                </div>
            </div>
            <div class="second-row">
                @if (sale().sortDate) {
                    <div class="date">{{ sale().sortDate | date: "dd.MM.yyyy" | dash }}</div>
                }
                @if (sale().residentialMeasuredArea) {
                    <div class="area">{{ sale().residentialMeasuredArea | dash | areaconverter }}</div>
                }
                <div class="floor">{{ sale().floor ? sale().floor + " etg" : "" }}</div>
                @if (sale().price && includeCommonDebt) {
                    <div class="value">{{ sale().price | number: "1.0-0" | dash }}</div>
                }
                @if (sale().priceExcludingCommonDebt && !includeCommonDebt) {
                    <div class="value">{{ sale().priceExcludingCommonDebt | number: "1.0-0" | dash }}</div>
                }
            </div>
        </div>
        <div class="icon">
            @if (estateListEditMode && shouldShowCartIcon) {
                <div class="icon cart" [class.in-cart]="inCart()" (click)="modifyCart($event)"></div>
            }
        </div>
    </div>
}
